module.exports = __webpack_public_path__ + "static/media/about.1ac9d127.svg";